import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/finance/revenue';
const countriesUrl = base_url+'api/admin/esCountries';
const subdomainTypeUrl = base_url+'api/admin/esSubdomainType';
const seriesTypeUrl = base_url+'api/admin/esSeriesSetup';

export const getData = async (params) => {
  const whereParam = params;
  const response = await api.post(path, whereParam);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};

export const getcountries = async () => {
    const response = await api.get(countriesUrl);
    return response.data.data;
};

export const getsubdomains = async () => {
  const response = await api.get(subdomainTypeUrl);
  return response.data.data;
};

export const getseries = async () => {
  const response = await api.get(seriesTypeUrl);
  return response.data.data;
};